// extracted by mini-css-extract-plugin
module.exports = {"InputLink":"InputLink_InputLink__26Qog","ExampleLink":"InputLink_ExampleLink__2w3Jx"};